export default "__VITE_ASSET__BsOH3Nqx__"